import { LANGUAGE_EN } from '@/utils/runtimeLocale';

const MAP_NAME_EN = {
  xin_jiang: 'Xinjiang',
  xi_zang: 'Tibet',
  nei_meng_gu: 'Inner Mongolia',
  qing_hai: 'Qinghai',
  si_chuan: 'Sichuan',
  hei_long_jiang: 'Heilongjiang',
  gan_su: 'Gansu',
  yun_nan: 'Yunnan',
  guang_xi: 'Guangxi',
  hu_nan: 'Hunan',
  shan_xi_1: 'Shaanxi',
  guang_dong: 'Guangdong',
  ji_lin: 'Jilin',
  he_bei: 'Hebei',
  hu_bei: 'Hubei',
  gui_zhou: 'Guizhou',
  shan_dong: 'Shandong',
  jiang_xi: 'Jiangxi',
  he_nan: 'Henan',
  liao_ning: 'Liaoning',
  shan_xi_2: 'Shanxi',
  an_hui: 'Anhui',
  fu_jian: 'Fujian',
  zhe_jiang: 'Zhejiang',
  jiang_su: 'Jiangsu',
  chong_qing: 'Chongqing',
  ning_xia: 'Ningxia',
  hai_nan: 'Hainan',
  tai_wan: 'Taiwan',
  bei_jing: 'Beijing',
  tian_jin: 'Tianjin',
  shang_hai: 'Shanghai',
  xiang_gang: 'Hong Kong',
  ao_men: 'Macau',
};

function isEnglish(language) {
  return language === LANGUAGE_EN;
}

function getFeatureEnglishName(feature) {
  return feature && feature.id ? MAP_NAME_EN[feature.id] : '';
}

export function getMapFeatureName(feature, language) {
  if (!feature || !feature.properties) {
    return '';
  }

  return isEnglish(language) ? getFeatureEnglishName(feature) || feature.properties.name : feature.properties.name;
}

export function getLocalizedMapName(mapJson, name, language) {
  const feature = mapJson.features.find((item) => item.properties && item.properties.name === name);
  return feature ? getMapFeatureName(feature, language) : name;
}

export function createLocalizedMapJson(mapJson, language) {
  const localizedMapJson = JSON.parse(JSON.stringify(mapJson));

  localizedMapJson.features.forEach((feature) => {
    feature.properties.name = getMapFeatureName(feature, language);
  });

  return localizedMapJson;
}

export function createMapOptions(mapJson, language) {
  return mapJson.features.map((feature) => ({
    label: getMapFeatureName(feature, language),
    value: feature.properties.name,
  }));
}
